var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "comment-replies__tabs" }, [
    _c(
      "div",
      { staticClass: "tabs tabs--comments" },
      _vm._l(_vm.tabs, function(tab) {
        return _c("TabsItem", { key: tab.order, attrs: { tab: tab } })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }